import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import Snackbar from 'material-ui/Snackbar';
import RaisedButton from 'material-ui/RaisedButton';
import { nullifyPublishAt, removeAllImages, removeVideo, submitPost, resetComposebox, wipeLinkData } from 'redux/modules/groupPostCompose';
import { FormSection, PageHeader } from 'components';
import { GMessageArea, GPostToArea, GPostTypeArea, GScheduleArea } from 'components/GroupPost';
import * as styles from './Group.scss';
import { tiePostToAd } from 'redux/modules/adsPlanner';
import moment from 'moment';
var GroupPostForm = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    config: state.config,
    groupPost: state.groupPostCompose,
    organization: state.organization.current,
    organizationId: state.organization.current.id,
    submittingPost: state.groupPostCompose.submittingPost
  };
}, {
  nullifyPublishAt: nullifyPublishAt,
  removeAllImages: removeAllImages,
  removeVideo: removeVideo,
  resetComposebox: resetComposebox,
  submitPost: submitPost,
  wipeLinkData: wipeLinkData,
  tiePostToAd: tiePostToAd
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(GroupPostForm, _Component);

  var _super = _createSuper(GroupPostForm);

  function GroupPostForm(props) {
    var _this;

    _classCallCheck(this, GroupPostForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function () {
      var accountSelected = false;

      _.forEach(_this.props.groupPost.selectedAccounts, function (value, key) {
        if (value) {
          accountSelected = true;
        }
      });

      if (accountSelected) {
        _this.props.submitPost(_this.props.groupPost, _this.props.organizationId).then(function (data) {
          browserHistory.push({
            pathname: '/global/group-posts'
          });
        })["catch"](function (err) {
          console.error(err);
        });
      } else {
        _this.setState({
          showSnackbar: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getQueueName", function () {
      if (_this.props.groupPost.selectedAccounts.facebookProfile) return 'Facebook Profile';
      if (_this.props.groupPost.selectedAccounts.facebookPage) return 'Facebook Page';
      if (_this.props.groupPost.selectedAccounts.twitter) return 'Twitter';
    });

    _this.state = {
      showSnackbar: false,
      snackbarMessage: 'Required fields missing.'
    };
    return _this;
  }

  _createClass(GroupPostForm, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.resetComposebox();
    }
    /** *********************************************************
     EVENT HANDLERS
     ***********************************************************/

  }, {
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this2 = this;

      var groupPost = this.props.groupPost;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: groupPost ? groupPost.existingPostId ? 'Edit Group Post' : 'New Group Post' : '',
        style: {
          marginBottom: 16
        }
      })), /*#__PURE__*/React.createElement(FormSection, {
        title: "Post To"
      }, /*#__PURE__*/React.createElement(GPostToArea, null)), /*#__PURE__*/React.createElement(FormSection, {
        title: "Message",
        titleStyle: {
          marginBottom: 0
        }
      }, /*#__PURE__*/React.createElement(GMessageArea, null)), /*#__PURE__*/React.createElement(FormSection, {
        title: "Post Type"
      }, /*#__PURE__*/React.createElement(GPostTypeArea, null)), /*#__PURE__*/React.createElement(FormSection, {
        title: "Schedule"
      }, /*#__PURE__*/React.createElement(GScheduleArea, null)), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'flex-end'
        }
      }, this.props.organization.gracePeriodState === '2' && /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, "This functionality has been disabled because this client's account is past due."), /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: groupPost.existingPostId ? 'Save Post' : 'Submit Post',
        onClick: this.handleSubmit,
        disabled: this.props.submittingPost || this.props.organization.gracePeriodState === '2'
      })), /*#__PURE__*/React.createElement(Snackbar, {
        open: this.state.showSnackbar,
        message: this.state.snackbarMessage,
        autoHideDuration: 4000,
        onRequestClose: function onRequestClose() {
          _this2.setState({
            showSnackbar: false
          });
        }
      }));
    }
  }]);

  return GroupPostForm;
}(Component), _defineProperty(_class2, "contextTypes", {
  router: PropTypes.object.isRequired
}), _temp)) || _class);
export { GroupPostForm as default };